import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'be-paragraph-editor',
  templateUrl: './paragraph-editor.component.html',
  styleUrls: ['./paragraph-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableParagraphEditorComponent implements AfterViewInit {
  private dialogRef = inject<MatDialogRef<TableParagraphEditorComponent, string>>(MatDialogRef);

  @ViewChild('stringInput') stringInput?: ElementRef<HTMLInputElement>;

  paragraphFormControl = new UntypedFormControl('');
  columnLabel?: string;

  constructor() {
    const dialogData = inject<{
      value: string;
      columnLabel?: string;
    }>(MAT_DIALOG_DATA);

    this.columnLabel = dialogData.columnLabel;
    this.paragraphFormControl.patchValue(dialogData.value);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.stringInput?.nativeElement.focus();
      this.stringInput?.nativeElement.select();
    });
  }

  enterKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.stopImmediatePropagation();
    }
  }

  closeDialog(): void {
    this.dialogRef.close(this.paragraphFormControl.value);
  }
}
